// API related actions
export const FETCHING_USER = '@@toyota/FETCHING_USER';
export const FETCHED_USER = '@@toyota/FETCHED_USER';
export const FETCHED_USER_FAILED = '@@toyota/FETCHED_USER_FAILED';
export const GET_USERS_REQUEST = '@@toyota/GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = '@@toyota/GET_USERS_SUCCESS';
export const GET_USERS_FAILED = '@@toyota/GET_USERS_FAILED';
